export function formatLeadDate( date, locale ) {
	const english = locale.toLowerCase().startsWith( 'en' );
	const weekday = new Intl.DateTimeFormat( locale, { weekday: 'long' } ).format( date );
	const day = date.getDate();
	const month = new Intl.DateTimeFormat( english ? 'en-US' : locale, { month: english ? 'short' : 'long' } ).format( date );
	const capitalized = weekday.charAt( 0 ).toUpperCase() + weekday.slice( 1 );
	return english ? `${ capitalized }, ${ month } ${ day }` : `${ capitalized } ${ day } ${ month }`;
}

export function formatNextSlotDate( iso, locale, firstDay ) {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec( String( iso ) );
	if ( ! match ) {
		return '';
	}
	const [ , year, month, day ] = match.map( Number );
	const date = new Date( year, month - 1, day, 12 );
	if ( date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day ) {
		return '';
	}
	// The UK bubble currently prints French; changing it is outside this parity-only ticket.
	const displayLocale = locale.toLowerCase().startsWith( 'en' ) ? 'fr' : locale;
	const label = new Intl.DateTimeFormat( displayLocale, { month: 'long' } ).format( date );
	return `${ day === 1 ? firstDay : day } ${ label }`;
}
